const messages = {
  en: {
    translations: {
      'full': 'Full',
      'remote': 'Remote',
      'expertise': 'Expertise',
      'days': 'days',
      'all': 'All',
      'regular': 'Regular',
      'irregular': 'Irregular',
      'notifications': 'Notifications',
      'view all notifications': 'View all notifications',
      header: {
        'message': 'Welcome back',
        'logout': 'Logout',
        'edit profile': 'Edit Profile'
      },
      menu: {
        'home': 'Home',
        'processes': 'Processes',
        'financial control': 'Financial control',
        'analytical report': 'Analytical report',
        'outher modules': 'Outher modules',
        'settings': 'Settings',
        'faq': 'F.A.Q',
        'request support': 'Request support',
        'new process': 'New process',
        'complete your profile': 'Complete your profile',
        'score': 'Score',
        'financial': 'Financial'
      },
      home: {
        'total processes': 'Total processes',
        'processes completed': 'Processes completed',
        'processes in progress': 'Processes in progress',
        'total completed': 'Total completed',
        'average execution time': 'Average execution time',
        'processes': 'Processes',
        'compared to (0 previous month)': 'Compared to (0 previous month)',
      },
      support: {
        'need help?': 'Need help?',
        'contact our support team through the contacts below': 'Contact our support team through the contacts below',
        'click here': 'Click here'
      },
      processes: {
        'search': 'Search',
        'export': 'Export',
        'selected': 'Selected',
        'sinister': 'Sinister',
        'date': 'Date',
        'provider': 'Provider',
        'well insured': 'Well insured',
        'regularity': 'Regularity',
        'in progress': 'In progress',
        'completed': 'Completed',
        'to edit': 'To edit',
        'report': 'Report'
      },
      edit: {
        'process steps': 'Etapas do processo',
        'registry': 'Registry',
        'files': 'Files',
        'social networks': 'Social networks',
        'interviews': 'Interviews',
        'local search': 'Local search',
        'public agencies': 'Public agencies',
        'conclused': 'Conclused',
        'finish': 'Finish',
        'to save': 'To save',
        'expenses': 'Expenses',
      }
    }
  }
}

export { messages }
